// Globals
import { FC, useMemo } from 'react';

// Components
import { Tooltip } from '@/ui';
import { StyledContent, StyledTooltipContent } from './GoogleMerchantSyncErrorSummaryStyles';

// Helpers
import { formatMerchantErrorSummary } from '../../helpers';

type TGoogleMerchantSyncErrorSummaryProps = {
  failureCode?: string | null;
  errorSummary?: Record<string, unknown> | null;
};

const GoogleMerchantSyncErrorSummary: FC<TGoogleMerchantSyncErrorSummaryProps> = ({ failureCode, errorSummary }) => {
  const { shortText, fullText } = useMemo(
    () => formatMerchantErrorSummary(failureCode, errorSummary),
    [failureCode, errorSummary],
  );

  return (
    <Tooltip title={<StyledTooltipContent>{fullText}</StyledTooltipContent>}>
      <StyledContent>{shortText}</StyledContent>
    </Tooltip>
  );
};

export default GoogleMerchantSyncErrorSummary;
